<footer>
  <p class="copyright">&copy;{{ year }} {{ tenantName() }}. All Rights Reserved.</p>
  <span class="version">v{{ appVersion }}</span>
</footer>
